// You can write more code here

/* START OF COMPILED CODE */

import BtnBack from "../prefabs/btns/BtnBack";
import UIPositionContainer from "../components/core/UIPositionContainer";
import BtnAudio from "../prefabs/btns/BtnAudio";
import BtnCarouselArrowLeft from "../prefabs/btns/BtnCarouselArrowLeft";
import BtnCarouselArrowRight from "../prefabs/btns/BtnCarouselArrowRight";
import LocaliseText from "../components/core/LocaliseText";
/* START-USER-IMPORTS */
import { BaseScene } from '@scarybeasties/phaser-framework-core/scenes';
import { Sounds } from '../sounds';
import { SceneData, TransitionPoint } from '../app-routing';
import UIButton from '../components/core/UIButton';
import { GameDataHandler } from '../game/GameDataHandler';
import {LevelNameValues, Worlds} from './../game/levels/level';
import LevelItem from "../prefabs/game/LevelItem";
/* END-USER-IMPORTS */

export default class LevelSelect extends BaseScene {

  constructor() {
    super("LevelSelect");

    /* START-USER-CTR-CODE */
    this.levelSelected = false;
    this.selectedLevel = 'level1';
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg
    const bg = this.add.image(960, 384, "level-select", "bg-lvl-country.jpg");

    // bgFade
    const bgFade = this.add.image(960, 384, "level-select", "bg-lvl-desert.jpg");
    bgFade.visible = false;
    bgFade.alpha = 0.5;
    bgFade.alphaTopLeft = 0.5;
    bgFade.alphaTopRight = 0.5;
    bgFade.alphaBottomLeft = 0.5;
    bgFade.alphaBottomRight = 0.5;

    // carousel
    const carousel = this.add.container(0, 0);

    // btnBack
    const btnBack = new BtnBack(this, 84, 84);
    this.add.existing(btnBack);

    // btnAudio
    const btnAudio = new BtnAudio(this, 1836, 84);
    this.add.existing(btnAudio);

    // btnCarouselArrowLeft
    const btnCarouselArrowLeft = new BtnCarouselArrowLeft(this, 43, 384);
    this.add.existing(btnCarouselArrowLeft);

    // btnCarouselArrowRight
    const btnCarouselArrowRight = new BtnCarouselArrowRight(this, 1892, 384);
    this.add.existing(btnCarouselArrowRight);

    // Title
    const title = this.add.container(960, 90);

    // label
    const label = this.add.text(0, 0, "", {});
    label.setOrigin(0.5, 0.5);
    label.text = "New text";
    label.setStyle({ "color": "#f6f45a", "fontFamily": "Acme-Regular", "fontSize": "70px", "shadow.offsetY":4,"shadow.fill":true});
    label.setPadding({"left":10,"top":10,"right":10,"bottom":10});
    title.add(label);

    // lists
    const levels: Array<any> = [];

    // btnBack (components)
    const btnBackUIPositionContainer = new UIPositionContainer(btnBack);
    btnBackUIPositionContainer.offsetX = 24;
    btnBackUIPositionContainer.offsetY = 24;
    btnBackUIPositionContainer.PinLeft = true;
    btnBackUIPositionContainer.PinTop = true;

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    // btnCarouselArrowLeft (components)
    const btnCarouselArrowLeftUIPositionContainer = new UIPositionContainer(btnCarouselArrowLeft);
    btnCarouselArrowLeftUIPositionContainer.offsetX = 20;
    btnCarouselArrowLeftUIPositionContainer.PinLeft = true;

    // btnCarouselArrowRight (components)
    const btnCarouselArrowRightUIPositionContainer = new UIPositionContainer(btnCarouselArrowRight);
    btnCarouselArrowRightUIPositionContainer.offsetX = 20;
    btnCarouselArrowRightUIPositionContainer.PinRight = true;

    // label (components)
    const labelLocaliseText = new LocaliseText(label);
    labelLocaliseText.copyId = "levelSelect";

    this.bg = bg;
    this.bgFade = bgFade;
    this.carousel = carousel;
    this.btnBack = btnBack;
    this.btnAudio = btnAudio;
    this.btnCarouselArrowLeft = btnCarouselArrowLeft;
    this.btnCarouselArrowRight = btnCarouselArrowRight;
    this.levels = levels;

    this.events.emit("scene-awake");
  }

  private bg!: Phaser.GameObjects.Image;
  private bgFade!: Phaser.GameObjects.Image;
  private carousel!: Phaser.GameObjects.Container;
  private btnBack!: BtnBack;
  private btnAudio!: BtnAudio;
  private btnCarouselArrowLeft!: BtnCarouselArrowLeft;
  private btnCarouselArrowRight!: BtnCarouselArrowRight;
  private levels!: Array<any>;

  /* START-USER-CODE */
  protected sceneData!: SceneData;
  protected levelSelected: boolean;
  protected selectedLevel: LevelNameValues;
  protected worldIndex:number = 0;
  private updatingCarousel:boolean = false;
  private mouseStartX:number = 0;
  private mousePrevX:number = 0;
  private mouseDown:boolean = false;
  private isDragging:boolean = false;

  public init(data: SceneData): void {
    this.sceneData = data;

    super.init(data);
  }

  public create() {
    super.create();
    this.editorCreate();

    this.btnBack.once(UIButton.events.clicked, this.back, this);

    this.worldIndex = GameDataHandler.getLastWorldPlayed(this);
    this.updateCarousel(1);



    this.btnCarouselArrowLeft.on(UIButton.events.clicked,this.moveCarouselLeft,this);
    this.btnCarouselArrowRight.on(UIButton.events.clicked,this.moveCarouselRight,this);

    this.levelSelected = false;

    this.input.on(Phaser.Input.Events.POINTER_DOWN, () => {
      this.mouseStartX = this.input.activePointer.x;
      this.mouseDown = true;
    });
    this.input.on(Phaser.Input.Events.POINTER_UP, () => {
      this.mouseDown = false;
      this.isDragging= false;
      if(Math.abs(this.mouseStartX - this.input.activePointer.x) > 200) {
        if (this.mouseStartX < this.input.activePointer.x) {
          this.moveCarouselLeft();
        } else {
          this.moveCarouselRight();
        }
      }
      else
      {
        this.add.tween({
          targets:this.carousel,
          x:0,
          duration:300,
          ease:Phaser.Math.Easing.Quadratic.InOut
        });
      }
    });

    if(this.worldIndex == Worlds.length-1)
    {
      this.btnCarouselArrowRight.visible = false;
    }
    else if(this.worldIndex == 0)
    {
      this.btnCarouselArrowLeft.visible = false;
    }

    this.app.AudioHandler.playSound(this, Sounds.Track.DesertMusicLoop, Sounds.Channel.Music, {
      volume: 0.1,
      loop: true
    });
  }

  update(time:number, delta:number)
  {
    super.update(time,delta);
    if(this.mouseDown)
    {
        if(!this.isDragging)
        {
          if (Math.abs(this.mouseStartX - this.input.activePointer.x) > 50) {
            this.isDragging = true;
            this.mousePrevX = this.input.activePointer.x;
          }
        }
        if (this.isDragging) {
          let dist = this.mousePrevX - this.input.activePointer.x;
          this.carousel.x -= dist;
          this.mousePrevX = this.input.activePointer.x;
        }
    }
  }

  // private update(time:number, delta:number)
  // {
  //   if(this.mouseDown)
  //   {
  //       if (Math.abs(this.mouseStartX - this.input.activePointer.x) > 50) {
  //         this.isDragging = true;
  //       }
  //       if (this.isDragging) {
  //         let dist = this.mousePrevX - this.input.activePointer.x;
  //         this.carousel.x -= dist;
  //         this.mousePrevX = this.input.activePointer.x;
  //       }
  //   }
  // }

  moveCarouselLeft()
  {
    if(this.updatingCarousel)
    {
      return;
    }
    if(this.worldIndex > 0) {
      this.worldIndex--;
      if(this.worldIndex == 0)
      {
        this.btnCarouselArrowLeft.visible = false;
      }
      this.btnCarouselArrowRight.visible = true;
      this.hideCarouselItems(1);
    }
    else
    {
      this.add.tween({
        targets:this.carousel,
        x:0,
        duration:300,
        ease:Phaser.Math.Easing.Quadratic.InOut
      });
    }
  }

  moveCarouselRight()
  {
    if(this.updatingCarousel)
    {
      return;
    }
    if(this.worldIndex < Worlds.length-1) {
      if(this.worldIndex == Worlds.length-2)
      {
        this.btnCarouselArrowRight.visible = false;
      }
      this.btnCarouselArrowLeft.visible = true;
      this.worldIndex++;
      this.hideCarouselItems(-1);
    }
    else
    {
      this.add.tween({
        targets:this.carousel,
        x:0,
        duration:300,
        ease:Phaser.Math.Easing.Quadratic.InOut
      });
    }

  }

  hideCarouselItems(dir:number)
  {
    this.app.AudioHandler.playSound(this, Sounds.Track.Swish2, Sounds.Channel.SFX, { volume: 0.5 });
    this.bgFade.setTexture(this.bg.texture.key,this.bg.frame.name);
    this.bgFade.visible = true;
    this.bgFade.alpha = 1;
    this.updatingCarousel = true;
    for (let i = 0; i < this.levels.length; i++) {
      const level = this.levels[i];

      const endX = level.x + (1920*dir);
      this.add.tween({
        targets: level,
        x: endX,
        duration: 500,
        ease: Phaser.Math.Easing.Cubic.InOut
      });
    }
    this.time.delayedCall(250, ()=>{this.updateCarousel(dir)}, undefined, this);
  }

  updateCarousel(dir:number)
  {
    this.carousel.x = 0;
    for(let i = 0; i < this.levels.length; ++i)
    {
      this.carousel.remove(this.levels[i]);
      this.levels[i].destroy(true);
    }
    this.levels = [];

    let worldPack = Worlds[this.worldIndex];
    this.bg.setTexture(this.bg.texture.key,worldPack.background);

    this.add.tween({
      targets: this.bgFade,
      alpha: 0,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.InOut
    }).on("complete",()=>{
      this.bgFade.visible = false;
      this.bgFade.alpha = 1;
    })

    GameDataHandler.updateLastWorldPlayed(this,this.worldIndex);
    let w = 280;
    for(let i = 0; i < worldPack.levels.length; ++i)
    {
      let levelPrefab = new LevelItem(this, (960-((w*(worldPack.levels.length-1))/2))+(w*i)  - (1920*dir), 384);
      this.add.existing(levelPrefab);
      this.carousel.add(levelPrefab);
      levelPrefab.starsUnlocked = GameDataHandler.getStarScore(this,worldPack.levels[i]);
      levelPrefab.highscore = GameDataHandler.getHighScore(this,worldPack.levels[i]);
      levelPrefab.levelNumber = (this.worldIndex*worldPack.levels.length)+(i+1);
      levelPrefab.linkedLevel = worldPack.levels[i];
      levelPrefab.unlocked = GameDataHandler.isLevelUnlocked(this,worldPack.levels[i]);
      levelPrefab.on(LevelItem.events.LevelSelected, this.onLevelSelected, this);
      levelPrefab.init();
      this.levels.push(levelPrefab);
    }

    this.events.emit("scene-awake");
    this.displayMenu(dir);

  }

  public back() {
    this.app.App.gotoNextScene(this, TransitionPoint.LevelSelectBack);
  }

  protected displayMenu(dir:number) {
    this.app.AudioHandler.playSound(this, Sounds.Track.Swish3, Sounds.Channel.SFX, { volume: 0.5 });
    for (let i = 0; i < this.levels.length; i++) {
      const level = this.levels[i];

      this.add.tween({
        targets: level,
        x: level.x + (1920*dir),
        duration: 500,
        ease: Phaser.Math.Easing.Cubic.InOut
      });
    }

    this.time.delayedCall(500, this.carouselAvailable, undefined, this);
  }

  private idleTimer!:Phaser.Time.TimerEvent;
  private carouselAvailable()
  {
    let allUnlocked = true;
    for (let i = this.levels.length-1; i > -1; i--) {
      if(!this.levels[i].unlocked || this.levels[i].highscore == 0)
      {
        allUnlocked = false;
      }
    }

    if(allUnlocked)
    {
      this.idleTimer?.remove();
      this.idleTimer = this.time.delayedCall(2000, this.pulseRandomLevel, undefined, this);
    }
    else
    {
      for (let i = this.levels.length-1; i > -1; i--) {
        if(this.levels[i].unlocked)
        {
          this.levels[i].pulseLevelButton(true);
          break;
        }
      }
    }
    this.updatingCarousel = false;
  }

  private pulseRandomLevel()
  {
    this.levels[Phaser.Math.Between(0,this.levels.length-1)].pulseLevelButton(false);
    this.idleTimer?.remove();
    this.idleTimer = this.time.delayedCall(6000, this.pulseRandomLevel, undefined, this);
  }

  protected onLevelSelected(selectedLevel: LevelItem) {

    this.add.tween({
      targets: [this.btnBack,this.btnCarouselArrowLeft,this.btnCarouselArrowRight],
      alpha: 0,
      duration: 300,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.removeEvents();



    this.selectedLevel = selectedLevel.linkedLevel;
    this.levelSelected = true;
    this.playLevel();
  }

  protected playLevel() {
    if (!this.sceneData.runSettings) this.sceneData.runSettings = {};
    this.sceneData.runSettings.selectedLevel = this.selectedLevel;
    GameDataHandler.updateLastLevelPlayed(this, this.selectedLevel);
    this.app.App.gotoNextScene(this, TransitionPoint.LevelSelectEnd, this.sceneData);
  }

  removeEvents()
  {
    this.btnCarouselArrowLeft.on(UIButton.events.clicked,this.moveCarouselLeft,this);
    this.btnCarouselArrowRight.on(UIButton.events.clicked,this.moveCarouselRight,this);
    for (let i = 0; i < this.levels.length; i++) {
      this.levels[i].off(LevelItem.events.LevelSelected, this.onLevelSelected, this);
    }
    this.btnBack.off(UIButton.events.clicked, this.back, this);
  }

  shutdown() {
    super.shutdown();
    this.removeEvents();

  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
